import style from "./userAccountNotVerified.module.css";
// import WarningIcon from "../../assets/Warning.svg";
import WarningIcon from "../../../assets/Warning.svg";
const UserAccountNotVerified = () => {
  return (
    <div className={style.container}>
      <div className={style.rectangle}>
        <img src={WarningIcon} alt="Warning" className={style.icon} />
        <div className={style.label}>
          <p className={style.mainText}>
            Your account is pending for administrative approval.
          </p>
          <p className={style.subText}>
            For account verification please{" "}
            <a href="/account-verification-status" className={style.clickHere}>
              click here
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserAccountNotVerified;
